export const SEARCH_TEXT_PARAM = 'searchText';
export const DEFAULT_COLUMN_WIDTH = '12.5%';
export const DOUBLE_COLUMN_WIDTH = '25%';
export const ACTIONS_KEY = 'actions';
export const SEARCH_STAGE_PARAM = 'searchStage';

export const ALL_ID = 'all';
